export default "__VITE_ASSET__4e076c17__"